import React, { Component } from 'react'
import './styles/PortfolioEdit.css'
import firebase from '../../firebase'

import Notifications, { notify } from 'react-notify-toast';

import PlaceholderImage from '../../assets/placeholder-image.png'

export default class PortfolioEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      artists: [],
      names: [],
      spotifyLinks: [],
      pictures: [],
      songs: [], // [artistKey, songKey]
      songTitles: [], // [artistKey, songKey]

      newArtistPic: PlaceholderImage,
      newArtistName: '',
      newArtistSpotify: '',

      newSongTitles: [],
      newSongFiles: [],
      uploadTexts: [], // for displaying progress per artist

      disabledForm: false,

      firstLoad: true,
    }

    this.show = notify.createShowQueue();
  }

  componentDidMount() {
    const artistsRef = firebase.database().ref('portfolio/artists');

    this.show('Data is loading. Please wait.', "warning", 2000);

    artistsRef.on('value', (snapshot) => {
      let artistsData = snapshot.val();

      var result = [];
      var artistNames = [];
      var artistPictures = [];
      var artistSongs = [];
      var spotifyLinks = [];

      var songTitles = [];

      var newSongTitles = [];
      var newSongFiles = [];
      var uploadTexts = [];

      for (var i in artistsData) {
        artistsData[i]['key'] = i;
        result.push(artistsData[i]);

        artistNames[i] = artistsData[i].name;
        artistPictures[i] = artistsData[i].picture;
        spotifyLinks[i] = artistsData[i].spotify;
        artistSongs[i] = artistsData[i].songs;

        newSongFiles[i] = null;
        newSongTitles[i] = '';
        uploadTexts[i] = '';

        songTitles[i] = [];
        for (var k in artistsData[i].songs) {
          artistsData[i].songs[k]['key'] = k;
          
          songTitles[i][k] = artistsData[i].songs[k].title;
        }
      }

      if (this.state.firstLoad) {
        this.show('Data loaded.', "success", 2000);
      }

      this.setState({
        artists: result,
        names: artistNames,
        pictures: artistPictures,
        spotifyLinks: spotifyLinks,
        songs: artistSongs,
        songTitles: songTitles,
        firstLoad: false,
        uploadTexts: uploadTexts
      });

    });
  }

  componentWillUnmount() {
    const artistsRef = firebase.database().ref('portfolio/artists');

    artistsRef.off();
  }

  updateArtistInfo = (key) => {
    const artistRef = firebase.database().ref('portfolio/artists/' + key);

    this.show('Data is updating...', "warning", 2000);

    // data to be updated
    let artistData = {
        spotify: this.state.spotifyLinks[key],
        name: this.state.names[key],
        picture: this.state.pictures[key],
      }

    if (this.state.songs[key]) {
      artistData['songs'] = this.state.songs[key]
    }

    artistRef.set(artistData, (error) => {

      this.setState({
        disabledForm: false
      });

      if (error) {
        this.show('Data failed to update.', "error", 5000);
      } else {
        this.show('Data Saved. Awesome!', "success", 5000);
      }
    })
  }

  addArtist = () => {
    const artistsRef = firebase.database().ref('portfolio/artists/');

    let artistData = {
      name: this.state.newArtistName,
      spotify: this.state.newArtistSpotify,
      picture: this.state.newArtistPic
    }

    let artistKey = artistsRef.push().key;

    this.show('Data being added...', "warning", 2000);

    artistsRef.child(artistKey).set(artistData, (error) => {
      this.setState({
        disabledForm: false
      });

      if (error) {
        this.show('Data failed to add.', "error", 5000);
      } else {
        this.show('Data Added. Awesome!', "success", 5000);
      }
    })
  }

  deleteArtist = (key) => {
    const artistRef = firebase.database().ref('portfolio/artists/' + key);

    artistRef.remove().then(() => {
      this.show('Data deleted.', "success", 5000);
    }).catch(() => {
      this.show('Data failed to delete.', "error", 5000);
    });
  }

  // SONG MODIFIERS
  uploadNewSong = (artistKey) => {
    // Get a reference to the storage service, which is used to create references in your storage bucket
    var storage = firebase.storage();

    // Create a storage reference from our storage service
    var songsStorageRef = storage.ref('songs');

    let fileToUpload = this.state.newSongFiles[artistKey];

    const artistsSongsRef = firebase.database().ref('portfolio/artists/' + artistKey + '/songs');
    const newSongKey = artistsSongsRef.push().key;

    var uploadTask = songsStorageRef.child(artistKey+'/'+newSongKey+'-'+fileToUpload.name).put(fileToUpload);

    // Register three observers:
    // 1. 'state_changed' observer, called any time the state changes
    // 2. Error observer, called on failure
    // 3. Completion observer, called on successful completion

    uploadTask.on('state_changed', (snapshot) => {
      // Observe state change events such as progress, pause, and resume
      // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;

      let uploadTexts = this.state.uploadTexts;

      uploadTexts[artistKey] = 'Upload is ' + progress.toFixed(1) + '% done.';

      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
        
          uploadTexts[artistKey] = 'Upload is paused';

          break;
        /*case firebase.storage.TaskState.RUNNING: // or 'running'

          break;*/
      }

      this.setState({
        uploadTexts: uploadTexts
      });
    }, (error) => {
      // Handle unsuccessful uploads

      let uploadTexts = this.state.uploadTexts;

      uploadTexts[artistKey] = "File wasn't uploaded.";

      this.setState({
        uploadTexts: uploadTexts
      });
    }, () => {
      // Handle successful uploads on complete
      // For instance, get the download URL: https://firebasestorage.googleapis.com/...
      uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
        

        this.show('Data is updating...', "warning", 2000);

        // data to be updated
        let newSong = {
          title: this.state.newSongTitles[artistKey],
          filename: fileToUpload.name,
          song: downloadURL
        }

        let uploadTexts = this.state.uploadTexts;

        uploadTexts[artistKey] = "File successfully uploaded.";

        this.setState({
          uploadTexts: uploadTexts
        });

        artistsSongsRef.child(newSongKey).set(newSong, (error) => {

          let newSongTitles = this.state.newSongTitles;

          newSongTitles[artistKey] = '';

          this.setState({
            disabledForm: false,
            newSongTitles: newSongTitles
          });

          if (error) {
            this.show('Data failed to update.', "error", 5000);
          } else {
            this.show('Data Saved. Awesome!', "success", 5000);
          }

        })
      });
    });

  }

  updateSongDetails = (artistKey, songKey) => {
    const artistsSongsRef = firebase.database().ref('portfolio/artists/'+artistKey+'/songs');

    let songData = {
      title: this.state.songTitles[artistKey][songKey],
      song: this.state.songs[artistKey][songKey].song,
      filename: this.state.songs[artistKey][songKey].filename
    }

    this.show('Song info being updated...', "warning", 2000);

    artistsSongsRef.child(songKey).set(songData, (error) => {
      this.setState({
        disabledForm: false
      });

      if (error) {
        this.show('Song info failed to update.', "error", 5000);
      } else {
        this.show('Song info updated. Awesome!', "success", 5000);
      }
    })
  }

  deleteSong = (artistKey, songKey) => {

    this.show('Song is being deleted...', "warning", 2000);

    // Get a reference to the storage service, which is used to create references in your storage bucket
    var storage = firebase.storage();

    // Create a storage reference from our storage service
    var songsStorageRef = storage.ref('songs');

    let song = this.state.songs[artistKey][songKey];

    // Create a reference to the file to delete
    var songFileRef = songsStorageRef.child(artistKey+'/'+songKey+'-'+song.filename);

    // Delete the file
    songFileRef.delete().then(() => {
      // File deleted successfully

      const artistsSongsRef = firebase.database().ref('portfolio/artists/' + artistKey + '/songs');

      artistsSongsRef.child(songKey).remove().then(() => {

        let newSongTitles = this.state.newSongTitles;

        newSongTitles[artistKey] = '';

        this.setState({
          disabledForm: false,
          newSongTitles: newSongTitles
        });

        this.show('Song is deleted.', "success", 2000);        

      }).catch((error) => {
        this.show("Song wasn't deleted. Error occured.", "error", 2000);        
      });


    }).catch((error) => {
      // Uh-oh, an error occurred!

      this.show("Song wasn't deleted. Error occured.", "error", 2000);
    });
  }

  // EVENT HANDLERS

  handleNameChange = (key, event) => {
    let names = this.state.names;

    names[key] = event.target.value;

    this.setState({
      names: names
    })
  }

  handleSpotifyChange = (key, event) => {
    let spotifyLinks = this.state.spotifyLinks;

    spotifyLinks[key] = event.target.value;

    this.setState({
      spotifyLinks: spotifyLinks
    })
  }

  handleImageChange = (key, event) => {
    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      let pictures = this.state.pictures;
      pictures[key] = e.target.result;

      this.setState({
        pictures: pictures,
      })
    }

    if (event.target.files[0]) {
      fileReader.readAsDataURL(event.target.files[0]);
    }

  }

  handleNewNameChange = (event) => {
    this.setState({
      newArtistName: event.target.value
    })
  }

  handleNewSpotifyChange = (event) => {
    this.setState({
      newArtistSpotify: event.target.value
    })
  }

  handleNewImageChange = (event) => {
    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      this.setState({
        newArtistPic: e.target.result,
      })
    }

    if (event.target.files[0]) {
      fileReader.readAsDataURL(event.target.files[0]);
    }
  }

  handleSongTitleChange = (artistKey, songKey, event) => {
    let songTitles = this.state.songTitles;

    songTitles[artistKey][songKey] = event.target.value;

    this.setState({
      songTitles: songTitles
    })
  }

  handleNewSongTitleChange = (artistKey, event) => {
    let newSongTitles = this.state.newSongTitles;

    newSongTitles[artistKey] = event.target.value;

    this.setState({
      newSongTitles: newSongTitles
    })
  }

  handleNewSongFileChange = (artistKey, event) => {
    let newSongFiles = this.state.newSongFiles;

    if (event.target.files[0]) {

      newSongFiles[artistKey] = event.target.files[0];

      this.setState({
        newSongFiles: newSongFiles
      })

    }
  }

  render() {

    let teamList = [];

    this.state.artists.forEach((element) => {

      const {key} = element;

      let songs = this.state.songs[key];

      let songList = [];

      // layout songs
      for (var i in songs) {
        songList.push(
          <div className = "song-list-item">
            <div className = "song-title-input">
              Title: <input className="txt-input" value={this.state.songTitles[key][i]}
                        onChange={this.handleSongTitleChange.bind(this, key, i)} />
            </div>

            <div className="song-link-container">
              Link: <input className="txt-input disabled" value={songs[i].song} disabled />
            </div>

            <div className = "song-button-container">
              <button className='btn btn-submit' onClick={this.updateSongDetails.bind(this, key, i)}>Update</button>
              <button className='btn btn-plain' onClick={this.deleteSong.bind(this, key, i)}>Delete</button>
            </div>
            
          </div>
        );
      }

      if (songList.length == 0) {
        songList.push(
          <div className="song-list-item">
            This artist has no songs.
          </div>
        );
      }

      // layout artists
      teamList.push(
        <div className="box box-lg portfolio-edit-list-item" key={key}>
          <div className="artist-details-container">

            <div className="picture-section">
              <img src={this.state.pictures[key]} />
              <input type="file" onChange={this.handleImageChange.bind(this, key)} />
            </div>

            <div className="name-location-section">
              <div>
                Name: <input className="txt-input"
                  value={this.state.names[key]}
                  onChange={this.handleNameChange.bind(this, key)} />
              </div>

              <div>
                Spotify: <input className="txt-input"
                  value={this.state.spotifyLinks[key]}
                  onChange={this.handleSpotifyChange.bind(this, key)}
                  placeholder="Paste here the link from Spotify" />
              </div>
            </div>

            <div className="buttons-section">
              <button className='btn btn-submit btn-span-80' onClick={this.updateArtistInfo.bind(this, key)}>Update Info</button>
              <button className='btn btn-plain btn-span-80' onClick={this.deleteArtist.bind(this, key)}>Delete Artist</button>
            </div>

          </div>

          <div className = "song-list-container">
            <div className="song-list-wrapper">

              <div className="song-label">Songs:</div>
              {songList}

              <div className="song-label">Add a song:</div>
              <div className="add-song-container">

                <div className="song-title-input">
                  Title: <input className="txt-input"
                                  value={this.state.newSongTitles[key]}
                                  onChange={this.handleNewSongTitleChange.bind(this, key)} />
                </div>

                <div className="song-file-input">
                  <div>
                    File: <input type="file"
                      onChange={this.handleNewSongFileChange.bind(this, key)} />
                  </div>
                  <div>
                    {this.state.uploadTexts[key]}
                  </div>
                </div>

                <div className="song-button-container">
                  <button className='btn btn-submit btn-span-80' onClick={this.uploadNewSong.bind(this, key)}>Upload & Add</button>
                </div>
              
              </div>

            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="team-edit-wrapper">
        <Notifications />
        <div className="team-edit-list-container">

          <div className="box box-lg team-edit-list-item">
            <div className="picture-section">
              <img src={this.state.newArtistPic} />
              <input type="file" onChange={this.handleNewImageChange} />
            </div>

            <div className="name-location-section">
              <div>
                Name: <input className="txt-input"
                  value={this.state.newArtistName}
                  onChange={this.handleNewNameChange} />
              </div>

              <div>
                Spotify: <input className="txt-input"
                          value={this.state.newArtistSpotify}
                          onChange={this.handleNewSpotifyChange}
                          placeholder="Paste here the link from Spotify" />
              </div>

              <div>
                <i>Note: To add songs, you must create an artist first.</i>
              </div>
            </div>

            <div className="publish-btn-container">
              <button className='btn btn-submit btn-span-80' onClick={this.addArtist}>Create Artist</button>
            </div>
          </div>

          <div className="label">Artists:</div>

          {teamList}
        </div>
      </div>
    )
  }
}
